module.exports = __webpack_public_path__ + "static/media/icon-windcreek.6e2b9f35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RewardIcon/icon-windcreek.svg
// module id = 1437
// module chunks = 1